import { render, staticRenderFns } from "./modal-order-process.vue?vue&type=template&id=4cd572fe"
import script from "./modal-order-process.vue?vue&type=script&lang=js"
export * from "./modal-order-process.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports